module.exports = __webpack_public_path__ + "media/MRI6-ad.c35a17b1.mp3";